import React from 'react';
import { StickyOfferBar } from './components/StickyOfferBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { BeforeAfter } from './components/BeforeAfter';
import { Problems } from './components/Problems';
import { WhatsIncluded } from './components/WhatsIncluded';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream pt-11" data-id="element-0" data-mp="28tmdqzjya4vn">
      <StickyOfferBar data-id="element-1" data-mp="28sbb5328r364" />
      <Hero data-id="element-2" data-mp="23vci6nubd29i" />
      <main data-id="element-3" data-mp="23vuokdaowwv5">
        <StatsBar data-id="element-4" data-mp="23w4ey1znd61d" />
        <Transformation data-id="element-5" data-mp="23ujl6el5pr4k" />
        <BeforeAfter data-id="element-6" data-mp="23t8fuac2cbbc" />
        <Problems data-id="element-7" data-mp="3ijxsgzk2wgo4" />
        <WhatsIncluded data-id="element-8" data-mp="3ikh5q2ysagvt" />
        <InstantAccess data-id="element-9" data-mp="3ij668fcdfvai" />
        <Bonuses data-id="element-10" data-mp="3ihv22ef0kliv" />
        <Pricing data-id="element-11" data-mp="3mlj9mx3nbh44" />
        <Guarantee data-id="element-12" data-mp="3ml14faz09sk2" />
        <Testimonials data-id="element-13" data-mp="3mkhm3t5g125i" />
        <Faq data-id="element-14" data-mp="3mjzpuwis6nxl" />
        <FinalCta data-id="element-15" data-mp="3mjg8bgx1m1k3" />
      </main>
      <Footer data-id="element-16" data-mp="3rcj846sey78q" />
    </div>;
}